/**
 * POST enquiry data to the local /api/contact endpoint (Express server).
 * Returns { ok: true } on success, throws on failure.
 */
export const submitIfysEnquiry = async ({ formValues }) => {
  const res = await fetch('/api/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      phone: formValues.phone,
      email: formValues.email,
      enquiry: formValues.enquiry,
      newsletter: formValues.newsletter ?? false,
      _hp: '',
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error ?? 'Failed to send enquiry');
  }

  return res.json();
};
